import React from 'react';
import { FadeIn } from './FadeIn';
export function ProductIntro() {
  return <section className="bg-crema py-24 px-6" data-id="element-346">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row gap-16 items-center" data-id="element-347">
        <div className="w-full md:w-1/2 flex justify-center" data-id="element-348">
          <FadeIn data-id="element-349">
            <div className="relative" data-id="element-350">
              <div className="absolute -inset-4 bg-lila-suave/30 rounded-3xl blur-xl" data-id="element-351"></div>
              <img src="https://cdn.magicpatterns.com/uploads/httGRv1CrMbBVj65D4mDnA/Mockup.png" alt="Duerme, Bebé. Duerme. Mockup" className="relative z-10 w-full max-w-md rounded-2xl shadow-2xl" data-id="element-352" />
              <div className="absolute -bottom-6 -right-6 z-20 bg-white text-azul-noche font-bold px-6 py-3 rounded-full shadow-lg border border-crema transform rotate-3" data-id="element-353">
                Diseñado para mamás latinas en EE.UU.
              </div>
            </div>
          </FadeIn>
        </div>

        <div className="w-full md:w-1/2 space-y-8" data-id="element-354">
          <FadeIn delay={0.1} data-id="element-355">
            <div className="flex items-center gap-3 mb-4" data-id="element-356">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1B2A4A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-357">
                <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" data-id="element-358" />
              </svg>
              <span className="text-azul-noche font-bold tracking-widest uppercase text-sm" data-id="element-359">
                Presentando
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-azul-noche font-serif leading-tight" data-id="element-360">
              Duerme, Bebé. Duerme.
            </h2>
            <p className="text-xl text-texto mt-4 font-medium" data-id="element-361">
              La guía completa de sueño infantil para mamás con bebés de 0 a 6
              meses
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-362">
            <div className="flex gap-4 text-sm font-bold text-azul-noche bg-white/50 inline-flex p-2 rounded-lg border border-white" data-id="element-363">
              <span className="px-3 py-1 bg-white rounded shadow-sm" data-id="element-364">
                60 láminas
              </span>
              <span className="px-3 py-1 bg-white rounded shadow-sm" data-id="element-365">
                7 capítulos
              </span>
              <span className="px-3 py-1 bg-white rounded shadow-sm" data-id="element-366">
                Sistema semana a semana
              </span>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-367">
            <ul className="space-y-4 text-lg text-texto" data-id="element-368">
              <li className="flex items-start gap-3" data-id="element-369">
                <svg className="flex-shrink-0 mt-1" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C9B8E8" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-370">
                  <polyline points="20 6 9 17 4 12" data-id="element-371"></polyline>
                </svg>
                <span data-id="element-372">No es otro libro genérico de sueño.</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-373">
                <svg className="flex-shrink-0 mt-1" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C9B8E8" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-374">
                  <polyline points="20 6 9 17 4 12" data-id="element-375"></polyline>
                </svg>
                <span data-id="element-376">
                  No está traducido del inglés con contexto cultural ajeno.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-377">
                <svg className="flex-shrink-0 mt-1" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C9B8E8" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-378">
                  <polyline points="20 6 9 17 4 12" data-id="element-379"></polyline>
                </svg>
                <span data-id="element-380">
                  No te va a pedir que ignores a tu bebé ni que te sientas mal
                  por cargarlo.
                </span>
              </li>
            </ul>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-381">
            <p className="text-xl font-serif italic text-azul-noche border-l-4 border-lila-suave pl-4 py-2" data-id="element-382">
              Es la guía que una mamá latina con un bebé de 0 a 6 meses necesita
              leer antes de pasar otra noche sin dormir.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}